// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = { 37: 1, 38: 1, 39: 1, 40: 1, 33: 1, 34: 1 }
var lastScrollTop = 0
function preventDefault (e) {
  e.preventDefault()
}

function preventDefaultDown (e) {
  if (0 > e.wheelDelta) {
    e.preventDefault()
  }
}

function preventDefaultUp (e) {
  if (0 < e.wheelDelta) {
    e.preventDefault()
  }
}

function preventDefaultForScrollKeys (e) {
  if (keys[e.keyCode]) {
    preventDefault(e)
    return false
  }
}

// modern Chrome requires { passive: false } when adding event
var supportsPassive = true
var wheelOpt = supportsPassive ? { passive: false } : false
var wheelEvent =
  'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel'

// call this to Disable down scroll
let disableDown = function () {
  enable()
  window.addEventListener('DOMMouseScroll', preventDefaultDown, false) // older FF
  window.addEventListener(wheelEvent, preventDefaultDown, wheelOpt) // modern desktop
  window.addEventListener('keydown', preventDefaultForScrollKeys, false)
}

// call this to Disable down scroll
let enableDown = function () {
  //Remove event listners for down scroll
  window.removeEventListener('DOMMouseScroll', preventDefaultDown, false) // older FF
  window.removeEventListener(wheelEvent, preventDefaultDown, wheelOpt) // modern desktop
  window.removeEventListener('keydown', preventDefaultForScrollKeys, false)
}

// call this to Disable up scroll
let disableUp = function () {
  enable()
  window.addEventListener('DOMMouseScroll', preventDefaultUp, false) // older FF
  window.addEventListener(wheelEvent, preventDefaultUp, wheelOpt) // modern desktop
  window.addEventListener('keydown', preventDefaultForScrollKeys, false)
}

// call this to Disable up scroll
let enableUp = function () {
  //Remove event listners for up scroll
  window.removeEventListener('DOMMouseScroll', preventDefaultUp, false) // older FF
  window.removeEventListener(wheelEvent, preventDefaultUp, wheelOpt) // modern desktop
  window.removeEventListener('keydown', preventDefaultForScrollKeys, false)
}

// call this to Disable
let disable = function () {
  window.addEventListener('DOMMouseScroll', preventDefault, false) // older FF
  window.addEventListener(wheelEvent, preventDefault, wheelOpt) // modern desktop
  window.addEventListener('keydown', preventDefaultForScrollKeys, false)
}

// call this to Enable
let enable = function () {
  enableDown()
  enableUp()

  //Remove event listner for both way scroll
  window.removeEventListener('DOMMouseScroll', preventDefault, false) // older FF
  window.removeEventListener(wheelEvent, preventDefault, wheelOpt) // modern desktop
  window.removeEventListener('keydown', preventDefaultForScrollKeys, false)
}
const pageScroll = {
  disable: disable,
  disableDown: disableDown,
  disableUp: disableUp,
  enable: enable
}

export default pageScroll
